<template>
  <p>COTOHA Call Centerへリダイレクト中...</p>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 't-login-from-sf',
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-login-from-sf', this.error ? 'error' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    window.addEventListener('message', this.openNewWindow);
    window.parent.postMessage('cccLoginWindowLoaded', '*');
  },
  unmounted() {
    window.removeEventListener('message', this.openNewWindow);
  },
  methods: {
    openNewWindow(event) {
      try {
        const sfGetData = JSON.parse(event.data);
        localStorage.setItem('sfClickToDial', sfGetData.data.phoneNumber);
        window.open('https://' + document.domain + '/login');
      } catch (err) {
        console.error(err);
        return;
      }
    },
  },
};
</script>
